import Vue from 'vue';

const mutations = {
  SET_CLASSES: (state, classes) => {
    state.classes = classes;
  },

  SET_TEACHERS(state, teachers) {
    state.teachers = teachers;
  },

  SET_COLUMNS: (state, columns) => {
    state.columns = columns;
  },

  SET_CURRENT_PAGE: (state, currentPage) => {
    state.currentPage = currentPage;
  },

  SET_PAGE_SIZE: (state, pageSize) => {
    state.pageSize = pageSize;
  },

  SET_TOTAL_COUNT: (state, count) => {
    state.count = count;
  },

  SET_REFRESH_DATE: (state, timestamp) => {
    state.lastRefreshDate = timestamp;
  },

  SET_ORDERING: (state, ordering) => {
    state.ordering = ordering;
  },

  SET_FILTER: (state, { key, value }) => {
    Vue.set(state.filters, key, value);
  },

  RESET_FILTERS: state => {
    state.filters = {};
  },

  SET_DATE_RANGE: (state, dateRange) => {
    state.dateRange = dateRange;
  },

  RESET_TEACHERS: state => {
    state.teachers = [];
  },

  SET_ORGANIZATIONS: (state, organizations) => {
    state.organizations = organizations;
  },

  RESET_ORGANIZATIONS: state => {
    state.organizations = [];
  },

  SET_FEATURE_GROUPS: (state, featureGroups) => {
    state.featureGroups = featureGroups;
  },

  RESET_FEATURE_GROUPS: state => {
    state.featureGroups = [];
  },

  SET_LEVELS: (state, levels) => {
    state.levels = levels;
  },

  SET_BULK_DELETE_MODE: (state, enableBulkDelete = true) => {
    state.bulkDeleteEnabled = enableBulkDelete;
  },

  RESET_LEVELS: state => {
    state.levels = [];
  },

  SET_CLASS_TYPES: (state, classTypes) => {
    state.classTypes = classTypes;
  },

  RESET_CLASS_TYPES: state => {
    state.classTypes = [];
  },

  SET_CLASS_POLICIES: (state, classPolicies) => {
    state.classPolicies = classPolicies;
  },

  RESET_CLASS_POLICIES: state => {
    state.classPolicies = [];
  },
};

export default mutations;
